<template>
	<div
	v-touch:tap="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	style="user-select: none;"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>

		<template v-if="data">
			<b-form-checkbox
				v-if="bulkMode"
				class="float-right ml-3"
				:checked="isSelected"
				@change="$emit('toggleSelectItem', data)"
				v-touch:tap.stop
				@click.native.stop
			/>
			<button class="btn btn-danger float-right ml-2" v-if="showDeleteBtn" v-touch:tap.stop="deleteFormResponse">{{$t('delete')}}</button>
			<button class="btn btn-secondary float-right" v-if="showAbandonBtn" v-touch:tap.stop="abandonFormResponse">{{$t('abandon')}}</button>

			<p class="mb-0">
				<template v-if="data.savedreport">
					<template v-if="data.num_users > 1">
						<template v-if="data.savedreport.savedreport_title">
							{{data.savedreport.savedreport_title}}:
						</template>
						<template v-else>
							{{$t('report-for')}}
						</template>
						{{data.num_users}} {{$t('students')}}
					</template>
					<template v-else>
						<template v-if="data.savedreport.savedreport_title">
							<strong class="mr-2">{{data.savedreport.savedreport_title}}: {{ data.savedreport.student_displayname }}</strong>
						</template>
						<template  v-else>
							<strong class="mr-2">{{$t('report-for')}} {{ data.savedreport.student_displayname }}</strong>
						</template>
					</template>
				</template>
				<template v-else>
					<strong class="mr-2">{{ data.formresponse_data.title }}</strong>
				</template>
				<span v-if="(data.formresponse_abandoned == '1')" class="badge badge-secondary">{{$t('abandoned')}}</span>
				<br />
				<span class="small">
					<template v-if="Number(data.formresponse_completed) == 1 && data.formresponse_dateofresponse">
						{{ this.$datetime.getLocaleStringFromTimeStamp(data.formresponse_dateofresponse, false) }}
					</template>
					<template v-else>
						{{ this.$datetime.getLocaleStringFromTimeStamp(data.created, false) }}
					</template>
				</span>
					<span class="badge" :class="deadlineClass" v-if="showDeadline">{{ $t('deadline-colon') }} {{ this.$datetime.getLocaleStringFromTimeStamp(data.formresponse_deadline, false) }}</span>
				<br />
				<template v-if="data.formresponse_message">
					<span class="small">{{ $stringhelper.truncate(data.formresponse_message, 250 , '...') }}</span>
					<br />
				</template>
				<span class="small">
					{{ $t('user-colon') }} <strong>{{ data.usersubject_displayname ? data.usersubject_displayname : data.user_displayname }}</strong>
					<template v-if="data.usersubject_displayname">
							<span class="badge badge-pill badge-info ml-1">
								{{ $t('submitted-by') }}
								<strong>{{ data.user_displayname }}</strong>
							</span>
					</template>
                    <template v-if="data.userreview_displayname">
						<template v-if="(data.formresponse_reviewed == '1')">
							<span class="badge badge-pill badge-success ml-1">
								{{ $t('reviewed-by') }}
								<strong>{{ data.userreview_displayname }}</strong>
							</span>
						</template>
						<template v-else>
							<span class="text-subtle ml-1">&#183;</span>
							{{ $t('review-colon') }} <strong>{{ data.userreview_displayname }}</strong>
						</template>
					</template>
					<template v-if="data.usersignoff_displayname">
						<template v-if="(data.formresponse_signedoff == '1')">
							<span class="badge badge-pill badge-success ml-1">
								{{ $t('signed-off-by') }}
								<strong>{{ data.usersignoff_displayname }}</strong>
							</span>
						</template>
						<template v-else>
							<span class="text-subtle ml-1">&#183;</span>
							{{ $t('signoff-colon') }}
							<strong>{{ data.usersignoff_displayname }}</strong>
						</template>
					</template>
                    <template v-if="data.usersubject_id">
						
							<span class="text-subtle ml-1">&#183;</span>
							{{ $t('subject-colon') }}
							<strong>{{ data.usersubject_displayname }}</strong>
					</template>
                    <template v-if="data.externaluser_name">
						<template v-if="(data.formresponse_signedoff == '1')">
							<span class="badge badge-pill badge-success ml-1">
								{{ $t('signed-off-by') }}
								<strong>{{ `${data.externaluser_name} (${$t('external-user')})` }} </strong>
							</span>
						</template>
						<template v-else>
							<span class="text-subtle ml-1">&#183;</span>
							{{ $t('signoff-colon') }}
							<strong>{{ `${data.externaluser_name} (${$t('external-user')})` }}</strong>
						</template>
					</template>
					<template v-if="awaitingFeedbackFromDisplayName">
						<br /><span class="text-subtle">{{ $t('awaiting-feedback-from-colon') }} <strong>{{ awaitingFeedbackFromDisplayName }}</strong></span>
					</template>
				</span>
			</p>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
export default {
	props: ['data', 'swipedLeftItem', 'bulkMode', 'selectedItems'],
	methods: {
		abandonFormResponse() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/abandon`, {
				data: {
					id: this.data.formresponse_id ,
					savedreport: {}
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		deleteFormResponse() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/delete`, {
				data: {
					id: this.data.formresponse_id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {
			if(e.button && e.button == 2) {
				return false;
			}

			if (this.bulkMode) {
				this.$emit('toggleSelectItem', this.data);
				return;
			}

			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.data);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.data);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.data);
		}
	},
	computed: {
		isSelected() {
			if (!this.selectedItems || !this.data) return false;
			return this.selectedItems.some(item => item.formresponse_id === this.data.formresponse_id);
		},
		showDeadline() {
			if(this.data.formresponse_deadline){
				if(this.data.formresponse_completed == false){
					return true;
				}
			}
			return false;
		},
		list() {
			return this.$route.params.list;
		},
		awaitingFeedbackFromDisplayName() {
			const me = this.$UserSession.getValue('id');
			const fr = this.data;
			if(fr.formresponse_completed != '1' && fr.user_id != me) {
				return fr.user_displayname;
			} else if(fr.formresponse_completed == '1' && fr.formresponse_signedoff != '1' && fr.usersignofffrom_id != me) {
				return fr.usersignoff_displayname;
			}
			return null;
		},
		deadlineClass(){
			var now = Date.now() / 1000;
			if(this.data.formresponse_deadline < now){
				return 'badge-danger';
			}
			if(this.data.formresponse_deadline < now + (3600*24*3)){
				return 'badge-warning';
			}
			return 'badge-info';
		},
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.formresponse_id == this.data.formresponse_id)
			&&
			(
				(
					this.$UserSession.getValue('id') == this.data.userfrom_id && this.data.formresponse_reviewed != '1' && this.data.formresponse_signedoff != '1'
				)
				|| this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS")
			);
		},
		showAbandonBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.formresponse_id == this.data.formresponse_id)
			&& this.data.formresponse_signedoff != '1' && this.data.formresponse_abandoned != '1'
			&& (
				[this.data.usersignofffrom_id, this.data.userfrom_id].includes(this.$UserSession.getValue('id'))
				||
				this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS")
			);
		}
	}
};
</script>
